import type { Worksheet } from "exceljs";

const FIRST_COLUMN = 1;

/**
 * Merge one row from column A through `lastColumn` (1-based, inclusive).
 *
 * Numeric on purpose, never a column letter: the `String.fromCharCode("A" + n - 1)` idiom yields
 * non-letters past column Z, and appended blank columns make a 26+ column section realistic. ExcelJS
 * builds the identical range either way, so widths that were already valid render byte-for-byte the same.
 */
export const mergeAcrossRow = (worksheet: Worksheet, row: number, lastColumn: number): void => {
	worksheet.mergeCells(row, FIRST_COLUMN, row, lastColumn);
};
